/**
 * reduceRectToTarget
 *
 * Reduce a rectangle from actual dimensions to target dimensions,
 * whilst keeping the aspect ratio and not enlarging.
 */
export function reduceRectToTarget(opts: { target: number; width: number; height: number }) {
    const reductionRatio = Math.min(1, opts.target / opts.width, opts.target / opts.height)

    return {
        width: opts.width * reductionRatio,
        height: opts.height * reductionRatio,
    }
}
